import {
  HEADERLIST,
  HEADER_FILTER_TYPE,
  STATUS_FILTER,
} from "../DashboardAppointmentsView/Constant";
import FilterIcon from "../../assets/newIcn.png";
import CalendarIcon from "../../assets/calendar.svg";

export const DEFAULT_MYPATIENTS_PAYLOAD = {
  consultation_filter: "",
  procedure_filter: "",
  page_no: 1,
  rows_per_page: 10,
  dr_name: "",
  start_date: "",
  end_date: "",
  status_filter: "all",
};

export const MYPATIENTS_APPOINTMENTS_HEADER = [
  {
    id: 1,
    title: HEADERLIST.DOCTORNAME,
    mobileFilterTitle: HEADERLIST.DOCTORNAME,
    filter_icon: FilterIcon,
    filter_type: HEADER_FILTER_TYPE.NORMAL,
    show_filter: false,
    menuData: [],
  },
  {
    id: 2,
    title: HEADERLIST.CONSULTATION,
    mobileFilterTitle: HEADERLIST.CONSULTATION,
    filter_icon: FilterIcon,
    filter_type: HEADER_FILTER_TYPE.CONSULTATION,
    show_filter: false,
    menuData: [],
    show_filter_searchbar: true,
    placeholderForSearch: "Search for Procedure",
  },
  {
    id: 3,
    title: HEADERLIST.STATUS,
    mobileFilterTitle: HEADERLIST.STATUS,
    filter_icon: FilterIcon,
    filter_type: HEADER_FILTER_TYPE.NORMAL,
    show_filter: false,
    menuData: STATUS_FILTER,
  },
  {
    id: 4,
    title: HEADERLIST.DATETIME,
    mobileFilterTitle: HEADERLIST.MOBILEDATE,
    filter_icon: CalendarIcon,
    filter_type: HEADER_FILTER_TYPE.DATE,
    show_filter: false,
    menuData: [],
  },
  {
    id: 6,
    title: HEADERLIST.ACTION,
  },
];

export const CONSULTATION_FILTER = [
  {
    name: "All",
    value: "all",
  },
  {
    name: "Tele-Consult Regular",
    value: "online-regular",
  },
  {
    name: "Tele-Consult Follow-Up",
    value: "online-followup",
  },
  {
    name: "In-Clinic Regular",
    value: "inclinic-regular",
  },
  {
    name: "In-Clinic Follow-Up",
    value: "inclinic-followup",
  },
  {
    name: "Instant",
    value: "instant",
  },
];

export const API_FILTER_LIST = {
  CONSULTATION: "consultation_filter",
  PROCEDURE: "procedure_filter",
  STARTDATE: "start_date",
  ENDDATE: "end_date",
  DOCTORNAME: "doctor_ids",
  DOCTOR_NAME: "doctor_name",
  PAGENO: "page_no",
  STATUS: "status_filter",
};

export const SELECTED_FILTER_TITLE = {
  CONSULTATION: "Consultation",
  DATE: "Selected Period",
  DOCTORNAME: "Doctor Name",
  STATUS: "Appointment Status",
  CLEARALL: "Clear All Filter",
};

export const UHID_DUPLICATE_ERROR =
  "This record is already exists, please enter unique record.";

export const getUHIDFormatError = (uhIDPrefix) => {
  return `Kindly enter valid UHID Ex- ${uhIDPrefix ? uhIDPrefix : "ABC"}0001`;
};

export const UHID_SINGLE_QUOTES_ERROR =
  "UHID field cannot take single & double quotes. Kindly enter something else.";
